<template>
  <div v-loading="loading">
    <div class="title">
      <div class="title-left">
        <el-checkbox v-model="checked" @change="handleCheckedAll()"
          >全选</el-checkbox
        >
      </div>
      <div class="title-rgiht">
        <div class="delete" @click="handleBatchDelete()">批量删除</div>
        <div class="comparison" @click="hanleComparison()">对比</div>
      </div>
    </div>
    <div class="minelist">
      <div class="container" v-for="(item, index) in dklist" :key="index">
        <div class="container-titile">
          <div
            class="container-titile-left"
            v-show="!item.transferAnnounceStatus"
          >
            <img src="@/assets/images/gg.png" alt="" />
            <span>未公告</span>
          </div>
          <div
            class="container-titile-left"
            v-show="item.transferAnnounceStatus"
          >
            <img src="@/assets/images/gg-activate.png" alt="" />
            <span style="color: #fd0101">已发布出让公告</span>
          </div>
          <div class="container-titile-right" @click="handeleDelete(item)">
            <img src="@/assets/images/shanchu.png" alt="" />
            <span>删除</span>
          </div>
        </div>
        <div class="content">
          <div style="display: flex; align-items: center">
            <div class="content-checked">
              <el-checkbox
                v-model="item.checked"
                @change="handleChangeChecked()"
              ></el-checkbox>
            </div>
            <div class="content-right" @click="goUrl(item)">
              <div class="content-img">
                <img :src="item.url" alt="" />
                <div class="content-dw" v-if="item.transaction == 2">
                  已成交
                </div>
                <div
                  class="content-dw1"
                  v-if="item.transaction == 1 && item.approvalStatus != 3"
                >
                  已下架
                </div>
              </div>

              <div class="content-container">
                <div class="parcelName">{{ item.parcelName }}</div>
                <div class="area">
                  {{ item.area }}亩 | {{ item.countyName }}
                </div>
                <div style="display: flex">
                  <div
                    :class="
                      item.supplyPeriod == 1
                        ? 'typ1'
                        : item.supplyPeriod == 3
                        ? 'typ2'
                        : 'typ3'
                    "
                    v-show="item.supplyPeriod"
                  >
                    {{
                      item.supplyPeriod == 1
                        ? "立等可供"
                        : item.supplyPeriod == 3
                        ? "计划可供"
                        : item.supplyPeriod == 4
                        ? "规划可用"
                        : ""
                    }}
                  </div>
                  <div v-if="item.labels" class="labelsname">
                    {{ item.labels[0].labelName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div
              class="dk-purchase"
              v-show="
                item.transferAnnounceStatus &&
                item.transaction == 1 &&
                item.approvalStatus != 4
              "
              @click="handlePurchase()"
            >
              我要买地
            </div>
            <div
              class="relation"
              v-if="item.transaction == 1 && item.approvalStatus == 3"
              @click="handleRelation(item)"
            >
              我要联系
            </div>
          </div>

          <el-dialog title="联系方式" :visible.sync="dialogVisible" width="30%">
            <div>联系人：{{ personinfo.person }}</div>
            <div style="margin-top: 10px">联系方式：{{ personinfo.phone }}</div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  infoFavoriteList,
  cancelFavoriteList,
  DKcancelAll,
} from "@/api/setting/investment.js";
import { Message } from "element-ui";
import { getUserInfo } from "@/api/login/index";
export default {
  data() {
    return {
      token: "",
      form: {
        current: 1,
        size: 100,
      },
      dklist: [],
      checked: false,
      flag: null,
      loading: false,
      dialogVisible: false,
      personinfo: {},
      userinfo: {},
    };
  },
  created() {
    this.token = sessionStorage.getItem("access_token")
      ? sessionStorage.getItem("access_token")
      : "";
    this.initialize();
  },
  mounted() {
    getUserInfo().then((res) => {
      if (res.data.success) {
        this.userinfo = res.data.data;
      }
    });
    this.$eventBus.on("isDetailRefresh", () => {
      this.initialize();
    });
  },
  methods: {
    goUrl(item) {
      console.log(item);
      if (item.transaction == 1 && item.approvalStatus == 3) {
        this.$router.push({
          path: "/land/detail",
          query: { id: item.parcelId },
        });
      }
    },
    initialize() {
      let token = sessionStorage.getItem("access_token")
        ? sessionStorage.getItem("access_token")
        : "";
      if (!token) {
        return;
      }
      infoFavoriteList(this.form).then((res) => {
        if (res.data.success) {
          let arr = [];
          this.$eventBus.emit("total", res.data.data.total);
          arr = res.data.data.records;
          arr.map((item) => {
            if (item.pronounceImages) {
              item.url =
                systemConfig.imgServer +
                systemConfig.imgApi +
                item.pronounceImages[0].filePath;
              item.checked = false;
            }
          });
          this.dklist = arr;
        }
      });
    },

    // 单个删除
    handeleDelete(item) {
      this.loading = true;
      cancelFavoriteList(item.parcelId).then((res) => {
        this.initialize();
        this.loading = false;
        if (res.data.success) {
          Message({
            message: res.data.msg,
            type: "success",
          });
          this.$eventBus.emit("Delete");
        } else {
        }
      });
      this.handleChangeChecked();
    },
    // 全选删除
    handeleAllDelete() {},
    // 全部选中
    handleCheckedAll() {
      this.dklist.map((item) => {
        item.checked = this.checked;
      });
    },
    // 批量删除
    handleBatchDelete() {
      this.loading = true;
      var list = [];
      this.dklist.map((item) => {
        if (item.checked) {
          let obj = {
            id: item.parcelId,
          };
          list.push(obj);
        }
      });
      var list1 = {
        list,
      };

      if (list.length == 0) {
        Message({
          message: "请勾选地块",
          type: "warning",
        });
        this.loading = false;
      } else {
        DKcancelAll(list1).then((res) => {
          this.loading = false;
          this.initialize();
          if (res.data.success) {
            this.checked = false;
            Message({
              message: res.data.msg,
              type: "success",
            });
          }
          this.$eventBus.emit("Delete");
        });
      }
    },
    //  单个选中框
    handleChangeChecked() {
      this.flag = this.dklist.every((item) => {
        return item.checked == true;
      });
      if (this.flag) {
        this.checked = true;
      }
    },
    // 对比
    hanleComparison() {
      var arr = [];

      this.dklist.map((item) => {
        if (item.checked) {
          let obj = {
            id: item.parcelId,
            name: item.parcelName,
            code: item.parcelCode,
          };
          arr.push(obj);
        }
      });
      if (arr.length < 2) {
        Message({
          message: "请勾选两个及两个以上的地块",
          type: "warning",
        });
      } else {
        this.$router.push({ path: "/land/contrast" });
        sessionStorage.setItem("contrastList", JSON.stringify(arr));
      }
    },
    // 我要买地
    handlePurchase() {
      //    console.log(this.userinfo);
      if (this.companyName == "") {
        Message({
          message: "请填写企业名称",
          type: "warning",
        });
      } else if (this.identityCode == "") {
        Message({
          message: "请填写社会信用代码",
          type: "warning",
        });
      } else {
        window.open("https://ggzy.yn.gov.cn/yn-tender/index.html#/login");
      }
      // window.open("https://ggzy.yn.gov.cn/yn-tender/index.html#/login");
    },
    // 联系方式
    handleRelation(data) {
      // console.log(data);
      this.dialogVisible = true;
      // debugger
      this.personinfo = data;
      // // console.log();
    },
  },
};
</script>

<style scoped>
>>> .el-checkbox__inner {
  width: 18px;
  height: 18px;
}

>>> .el-checkbox__inner::after {
  height: 8px;
  left: 6px;
  top: 2px;
}

.title {
  width: 98%;
  margin: auto;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* background: red; */
  padding-bottom: 10px;
}

.title-left {
  margin-left: 10px;
}

.title-rgiht {
  display: flex;
  height: 30px;
  align-items: center;
  /* margin-bottom: 10px; */
}

.delete {
  width: 75px;
  height: 26px;
  line-height: 26px;
  color: #2c83f6;
  background: #fff;
  border: 1px solid #2c83f6;
  text-align: center;
  font-size: 0.85rem;
  margin-right: 15px;
  border-radius: 6px;
  cursor: pointer;
}

.comparison {
  background: #fff;
  width: 75px;
  height: 26px;
  line-height: 26px;
  color: #2c83f6;
  border: 1px solid #2c83f6;
  text-align: center;
  font-size: 0.85rem;
  border-radius: 6px;
  cursor: pointer;
}

.container {
  width: 98%;
  margin: 10px auto;
  height: 150px;
  border: 1px solid #e8e8e8;
}

.container-titile {
  width: 100%;
  height: 32px;
  margin: auto;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  background: #f4f4f4;
  justify-content: space-between;
}

.container-titile-left {
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container-titile-left img {
  width: 18px;
}

.container-titile-left span {
  margin-left: 5px;
  font-size: 0.85rem;
  color: #969696;
}

.container-titile-right {
  margin-right: 10px;
  font-size: 0.85rem;
  color: #2c83f6;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.container-titile-right img {
  width: 18px;
}

.container-titile-right span {
  margin-left: 5px;
}

.content {
  width: 100%;
  height: 116px;
  display: flex;
  align-items: center;
  /* background: red; */
  justify-content: space-between;
}
.content-dw {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(187, 253, 196, 0.4);
  color: rgb(0, 114, 62);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.05rem;
  font-weight: 600;
  z-index: 99;
}
.content-dw1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fdbbbb66;
  color: #ff1414;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.05rem;
  font-weight: 600;
  z-index: 99;
}
.content-checked {
  width: 10%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  margin-right: 10px;
}

.content-right {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.content-img {
  position: relative;
  width: 150px;
  height: 100px;
}
.content-img img {
  width: 100%;
  height: 100%;
}

.content-container {
  width: 250px;
  margin-left: 10px;
}

.parcelName {
  height: 24px;
  line-height: 24px;
  font-size: 1rem;
  color: #2c83f6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.area {
  height: 30px;
  line-height: 30px;
  font-size: 0.85rem;
  color: #7c7c7c;
}

.typ1 {
  width: 70px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background: rgb(2, 214, 74);
  font-size: 0.75rem;
  color: #fff;
  border-radius: 4px;
}

.typ2 {
  width: 70px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background: rgb(73, 122, 255);
  font-size: 0.75rem;
  color: #fff;
  border-radius: 4px;
}

.typ3 {
  width: 70px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background: rgb(255, 174, 17);
  font-size: 0.75rem;
  color: #fff;
  border-radius: 4px;
}

.labelsname {
  width: 120px;
  height: 24px;
  line-height: 24px;
  border-radius: 4px;
  text-align: center;
  background: #dafffe;
  color: #16c1b3;
  font-size: 0.85rem;
  margin-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.minelist {
  height: 580px;
  width: 100%;
  overflow-y: auto;
}

.minelist::-webkit-scrollbar {
  width: 5px;
}

.minelist::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 5px;
}

.dk-purchase {
  width: 80px;
  height: 25px;
  background: #169bd5;
  text-align: center;
  line-height: 25px;
  border-radius: 4px;
  color: #fff;
  font-size: 0.85rem;
  cursor: pointer;
  margin-right: 15px;
  margin-bottom: 15px;
}

.relation {
  width: 80px;
  height: 25px;
  background: #169bd5;
  text-align: center;
  line-height: 25px;
  border-radius: 4px;
  color: #fff;
  font-size: 0.85rem;
  cursor: pointer;
  margin-right: 15px;
}
</style>